module.exports =
  '_GROUP_EVENT':
    'TITLE_EDIT': 'Edit Event'
    'TITLE_CREATE': 'Create Event'
    'CUSTOMIZE_EVENT': 'Customizing the Event'
    'ADD_COVER_IMAGE': 'Add Event cover image'
    'SELECT_PHOTO': 'Select photo'
    'UPLOAD_PHOTO': 'Upload photo'
    'CREATE_TITLE': 'Create event'
    'EVENT_NAME': 'Event Name'
    'PERIOD_NAME': 'Period'
    'START_DATE': 'Start Date'
    'END_DATE': 'End Date'
    'VALID_DATE': 'End date must be great than or equals to start date.'
    'LOCATION': 'Location'
    'DESCRIPTION': 'Description'
    'CANCEL': 'Cancel'
    'SAVE': 'Save'
    'PARTICIPANTS' : 'Participants'
    'NONPARTICIPANTS': 'Non-participation'
    'CREATE_EVENT': 'Create Event'
    'DELETE_EVENT': 'Delete Event'
    'EVENT_LIST': 'Event List'
    'SELECT_SCORE_CARD': 'Select a score card to be submitted'
    'VIEW_RANK': 'Referring to the ranking of this event.'
    'LIST_SUBMITTED_SCORE': 'Submitted score.'
    'DELETE': 'Delete'
    'SUBMIT': 'Submit'
    'SUBMITTED': 'Submitted'
    'CONFIRM_MESS': 'Are you sure to delete?'
    'VIEW_DETAIL': 'View detail'
    'CLOSE_DETAIL': 'Close'
    'AVG_SCORE_RANK': 'Average score ranking'
    'AVG_PUTT_RANK': 'Average putt ranking'
    'PER_ON_RATE_RANK': 'Per on Rate Ranking'
    'BIRDIE_RATE_RANK': 'Birdie Rate Ranking'
    'PER_RATE_RANK': 'Per Rate Ranking'
    'SUBMIT_DELETE_SCORCARD': 'Submit / delete scorecard'
    'OVERALL_SCORE_ANALYSIS': 'Overall score analysis'
    'SCORE_ANALYSIS': 'Score analysis of this round'
    'FILTER_PERIOD': 'Period'
    'FILTER_COURSE': 'Course'
    'FILTER_STATUS': 'Status'
    'FILTER': 'Filter'
    'FILTER_PC': 'Filter the display conditions'
    'FILTER_CLOSE': 'Close'
    'FILTER_PERIOD_ALL': 'Entire period'
    'FILTER_PERIOD_THREE_MONTH': 'Last 3 months'
    'FILTER_PERIOD_SIX_MONTH': 'Last 6 months'
    'FILTER_COURSE_ALL': 'All of the courses'
    'FILTER_STATUS_ALL': 'All'
    'FILTER_STATUS_DONE': 'Submitted'
    'FILTER_STATUS_NOTYET': 'Not submitted'
    'FILTER_MODAL_HEADER': 'Select target courses'
    'FILTER_MODAL_FOOTER': 'Done'
    'FILTER_BY_CONDITION': 'Filter by this condition'
    'FILTER_SELECT_COURSE': 'SELECT COURSE >'
    'CROP':
      'TITLE': 'Crop'
      'CANCEL': 'Cancel'
      'DONE': 'Done'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/i18n/en.coffee